module.exports = __webpack_public_path__ + "media/images/contacts_icon-0e9feeb4254e42b278ff11afe6d8e7c2.svg";